<template>
  <div>
    <!-- Contenu de la page -->
    <div class="container-fluid">
      <BarreFiltres ref="barreFiltres" :filtres="filtres" @appliquer-filtre="appliquerFiltre($event)" />
      <BarreActions ref="barreActions" :actions="actions" @appliquer-action="executerAction($event)" />

      <ModalImportMercuComplementaire ref="modalImportMercuComplementaire" :listeFournisseurs="listeTousFournisseurs" :optionsFamilles="optionsFamilles" @refreshMercuriale="obtenirListeMercuriales($event)" />
      <ModalExportMercuComplementaire ref="modalExportMercuComplementaire" :nomFournisseur="mercurialeSelectionnee.nomFournisseur" :nomFamille="mercurialeSelectionnee.nomFamille" @exporterMercuriale="exporterMercuriale($event)" />
      <ModalDemandeDate ref="modalDemandeDate" :titreModal="'Arrêter la mercuriale'" :titreDate="'Choisir une date de fin'" :dateSelectionnee="dateMinimumArret" :dateMinimum="dateMinimumArret" :dateMaximum="dateFinTarifSelectionnee" @dateChoisie="arreterMercuriale($event)" />

      <div class="card table-scroll height-responsive-100">
        <table class="table table-bordered table-sm text-center table-header"> <!-- style="display:block;max-height:800px;overflow:auto" -->
        <!--<table class="table table-bordered text-center">-->
          <colgroup>
            <col width="180">
            <col width="200">
            <col>
            <col width="200">
            <col width="200">
            <col width="200">
            <col width="50">
          </colgroup>
          <thead>
            <th class="watchMe" @click="trierListe('codeFamille')">Code Famille<i v-if="afficheIconeTri('codeFamille')" :class="iconeSensTri"></i></th>
            <th class="watchMe" @click="trierListe('nomFamille')">Famille<i v-if="afficheIconeTri('nomFamille')" :class="iconeSensTri"></i></th>
            <th class="watchMe" @click="trierListe('nomFournisseur')">Fournisseur<i v-if="afficheIconeTri('nomFournisseur')" :class="iconeSensTri"></i></th>
            <th class="watchMe" @click="trierListe('dateDebutTarif')">Date début Tarif<i v-if="afficheIconeTri('dateDebutTarif')" :class="iconeSensTri"></i></th>
            <th class="watchMe" @click="trierListe('dateFinTarif')">Date Fin Tarif<i v-if="afficheIconeTri('dateFinTarif')" :class="iconeSensTri"></i></th>
            <th class="watchMe" @click="trierListe('nombreDeProduits', true)">Nombre de produits<i v-if="afficheIconeTri('nombreDeProduits')" :class="iconeSensTri"></i></th>
            <th></th>
          </thead>
        </table>
        <div class="table-body">
          <table class="table table-bordered table-sm text-center">
            <colgroup>
              <col width="180">
              <col width="200">
              <col>
              <col width="200">
              <col width="200">
              <col width="200">
              <col width="45">
            </colgroup>
            <tbody :key="this.keySel">
              <tr :class="[{'ligne-selectionnee':ligneEstSelectionnee(mercu)}]" v-for="(mercu, iMercu) in mercurialesComplementaireFiltrees" :key="iMercu" @click="selectionnerLigne(mercu, iMercu)">
                <template>
                  <td>{{ mercu.codeFamille }}</td>
                  <td>{{ mercu.nomFamille }}</td>
                  <td>{{ mercu.nomFournisseur }}</td>
                  <td>{{ formatHumanDateAvecSlashes(mercu.dateDebutTarif) }}</td>
                  <td>{{ formatHumanDateAvecSlashes(mercu.dateFinTarif) }}</td>
                  <td>{{ mercu.nombreDeProduits }}</td>
                  <td>
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarreFiltres from '@/components/Divers/BarreFiltres'
import BarreActions from '@/components/Divers/BarreActions'
import { connecteData } from "@/mixins/connecteData"
import { showAlerts } from "@/mixins/alerts"
import { formatageDate, formatHumanDateAvecSlashes } from '@/mixins/dateFormats'
import { chargerFournisseursStandardEtSpeciaux } from '@/api/gpao/fournisseurs'
import { exporterProduitsComplementaires, obtenirMercurialesComplementaires, supprimerProduitsComplementaires, arreterMercurialesComplementaires, exporterTrameViergeProduitsComplementaires } from '@/api/gpao/mercuriales'
import { lancerTelechargementDeResponse } from "@/helpers/utils"
import ModalImportMercuComplementaire from '@/components/Divers/ModalImportMercuComplementaire'
import ModalExportMercuComplementaire from '@/components/Divers/ModalExportMercuComplementaire'
import ModalDemandeDate from '@/components/Divers/ModalDemandeDate'
import _ from 'lodash'

export default {
  name: "PageDetailMercurialeComplementaire",
  components: {
    BarreFiltres,
    BarreActions,
    ModalImportMercuComplementaire,
    ModalExportMercuComplementaire,
    ModalDemandeDate
  },
  mixins: [connecteData, showAlerts, formatageDate, formatHumanDateAvecSlashes],
  data() {
    return {
      keySel: 0,
      triAsc: null,
      colonneTriee: "",
      idFamilleSelectionnee: null,
      idFournisseurSelectionnee: null,
      dateDebutTarifSelectionnee: null,
      dateFinTarifSelectionnee: null,
      idMercurialeSelectionnee: null,
      filtreFamilles : {},
      listeTousFournisseurs : [], //Tous les fournisseurs
      listeFamilles : [], //Les familles qui ont une mercuriale complémentaire, format combo
      listeFournisseurs : [], //Les fournisseurs qui ont une mercu complémentaire
      filtreFournisseurs : {},
      filtreDate : {},
      mercurialesComplementaire: [],
      mercurialesComplementaireFiltrees: [],
      optionsFamilles: [], //Toutes les familles au format combo
      optionsFournisseurs: [], 
      enExportation: false,
      filtres: {
        dateTarif: {
          label: "Tarif actif au",
          champ: "datepicker",
          required: true,
          verrouClavier: true,
          selection: null,
          initialiser(contexte) {
            contexte.filtres.dateTarif.selection = null
          },
          filtrer(contexte, mercu) {
            let filtre = contexte.filtres.dateTarif
            contexte.filtreDate = filtre.selection
            if (mercu) {
              if (!filtre || !filtre.selection)
                return true
              else
                return contexte.formatDateAvecTirets(mercu.dateDebutTarif) <= contexte.formatDateAvecTirets(filtre.selection) &&  contexte.formatDateAvecTirets(mercu.dateFinTarif) >= contexte.formatDateAvecTirets(filtre.selection)
            } else {
              contexte.appliquerFiltres()
            }
          }
        },
        familles: {
          label: "Sélectionner une famille",
          champ: "select",
          width: "300px",
          options: [],
          selection: [],
          initialiser(contexte) {
            let filtre = contexte.filtres.familles
            filtre.options = contexte.listeFamilles//.map(zs => new { valeur: zs, texte: zs })
            filtre.selection = []

          },
          filtrer(contexte, mercu) {
            contexte.filtreFamilles = contexte.filtres.familles.selection
            if (mercu) {
              if (!contexte.filtreFamilles || !contexte.filtreFamilles.valeur) {
                return true
              }
              else {
                contexte.selectFamilleDeProduit(contexte.filtreFamilles)
                return mercu.familleId === contexte.filtreFamilles.valeur
              }
            } else {
              contexte.appliquerFiltres()
            }
          }
        },
        fournisseurs: {
          label: "Sélectionner un fournisseur",
          champ: "select",
          width: "300px",
          options: [],
          selection: [],
          initialiser(contexte) {
            let filtre = contexte.filtres.fournisseurs
            filtre.options = contexte.construireListeFournisseur(null) //.map(zs => new { valeur: zs, texte: zs })
            filtre.selection = []
          },
          filtrer(contexte, mercu) {
            contexte.filtreFournisseurs = contexte.filtres.fournisseurs.selection
            if (mercu) {
              if (!contexte.filtreFournisseurs || !contexte.filtreFournisseurs.valeur)
                return true
              else 
                return mercu.fournisseurId === contexte.filtreFournisseurs.valeur
            } else {
              contexte.appliquerFiltres()
            }
            //contexte.filtrer()
            
          }
        },
        reinitialiser: {
          label: "Réinitialiser les filtres",
          champ: "btn",
          filtrer(contexte) {
            contexte.filtres.barreGauche.forEach(f => {
              if (f.initialiser) {
                f.initialiser(contexte)
              }
            })
            contexte.triAsc = null
            contexte.appliquerFiltres()
          }
        },
        // Appeler "this.filtres.initialiser(this)" dans mounted() => génère le tableau de filtres utilisés pour afficher les filtres dans la barre de filtres
        barreGauche: [],
        barreDroite: [],
        initialiser(contexte) {
          //contexte.reinitialiser()
          contexte.filtres.barreGauche = [ contexte.filtres.dateTarif, contexte.filtres.familles, contexte.filtres.fournisseurs ]
          contexte.filtres.barreDroite = [ contexte.filtres.reinitialiser ]
          contexte.filtres.barreGauche.forEach(f => {
            if (f.initialiser) {
              f.initialiser(contexte)
            }
          })
          contexte.keyFiltres += 1
        },
        filtrer(contexte, commande) {
          return !contexte.filtres.barreFiltres.find(f => !f.filtrer(contexte, commande))
        }
      },
      actions: {
        // Boutons à afficher dans la barre d'action
        // Exemple :
        /*
        nomAction: {
          label: Label affiché sur le bouton (string),
          disabled: Etat actif/inactif par défaut du bouton (bool),
          class: Classe CSS (btn-primary, btn-success, btn-warning ou btn-danger) à appliquer sur le bouton (par défaut : "btn-primary" est appliqué => il s'agit du bouton bleu Agap'pro) (string)
          methode(contexte) {
            // => contexte équivaut à this (mais this ne fonctionne pas car l'initialisation de data n'est pas encore terminée, donc data n'est pas encore rattaché à this)
            traitements à exécuter lors du clic sur le bouton
            les traitements définis dans cette page doivent être appelés sous la forme : contexte.traitement()

            Remarque : pour que le système fonctionne, il faut déclarer la méthode ci-dessous dans la section "methods" de cette page
            executerAction(methode) {
              methode(this)
            }

          }
        }
        */
        exporter: {
          label: "Exporter",
          disabled: true,
          methode(contexte) {
            contexte.exporterProduits(false)  
          }
        },
        exporterVierge: {
          label: "Exporter Trame Vierge",
          disabled: false,
          methode(contexte) {
            contexte.exporterProduits(true)  
          }
        },
        importer: {
          label: "Importer",
          disabled: false,
          methode(contexte) {
            contexte.importerProduits()
          }
        },
        supprimer: {
          label: "Supprimer",
          disabled: true,
          class: "btn-danger",
          methode(contexte) {
            //il est possible de supprimer l'ensemble des tarifs pour une date de début dans le futur uniquement
            contexte.supprimerProduits()
          }
        },
        arreter: {
          label: "Arrêter la mercuriale",
          disabled: true,
          class: "btn-danger",
          methode(contexte) {
            //il est possible de supprimer l'ensemble des tarifs pour une date de début dans le futur uniquement
            contexte.demandeDateFin()
          }
        },
        // Appeler "this.actions.initialiser(this)"" dans mounted() => génère les tableaux d'actions utilisés pour afficher les boutons à gauche et à droite de la barre d'actions
        barreGauche: [],
        barreDroite: [],
        initialiser(contexte) {
          contexte.actions.barreGauche = [ contexte.actions.exporter, contexte.actions.exporterVierge, contexte.actions.importer ]
          contexte.actions.barreDroite = [ contexte.actions.arreter, contexte.actions.supprimer ]
        },
        // A gérer en cas de boutons à activer/désactiver (créer une méthode par groupe de boutons à activer/désactiver)
        disable(actions, disabled) {
          let actionsATraiter = [ ]
          actionsATraiter.forEach(a => a.disabled = disabled)
        },
        disableImporter(actions, disabled) {
          let actionsATraiter = [ actions.importer ]
          actionsATraiter.forEach(a => a.disabled = disabled)
        },
        disableExporter(actions, disabled) {
          let actionsATraiter = [ actions.exporter ]
          actionsATraiter.forEach(a => a.disabled = disabled)
        },
        disableSupprimer(actions, disabled) {
          let actionsATraiter = [ actions.supprimer ]
          actionsATraiter.forEach(a => a.disabled = disabled)
        },
        disableArreter(actions, disabled) {
          let actionsATraiter = [ actions.arreter ]
          actionsATraiter.forEach(a => a.disabled = disabled)
        },
        /*disableEnregistrer(actions, disabled) {
          let actionsATraiter = [ actions.enregistrer ]
          actionsATraiter.forEach(a => a.disabled = disabled)
        }*/
      }
    }
  },
  computed: {
    iconeSensTri() {
      return !this.triAsc ? "ml-1 fas fa-caret-up" : "ml-1 fas fa-caret-down"
    },
    mercurialeModifiable() {
      return this.dateDebutTarifSelectionnee && this.formatDatePourApiSansSeparation(this.dateDebutTarifSelectionnee) > this.formatDatePourApiSansSeparation(new Date())
    },
    mercurialeArretable() {
      return this.dateFinTarifSelectionnee && this.formatDatePourApiSansSeparation(this.dateFinTarifSelectionnee) > this.formatDatePourApiSansSeparation(this.dateMinimumArret)
    },
    mercurialeSelectionnee() {
      return this.mercurialesComplementaireFiltrees.find(m => m.familleId === this.idFamilleSelectionnee && m.fournisseurId === this.idFournisseurSelectionne && this.formatDatePourApiSansSeparation(m.dateDebutTarif) === this.formatDatePourApiSansSeparation(this.dateDebutTarifSelectionnee)) ?? {}
    },
    dateMinimumArret() {
      if (this.mercurialeModifiable)
        return this.dateDebutTarifSelectionnee
      return new Date()
    }
  },
  methods: {
    appliquerFiltres() {
      this.mercurialesComplementaireFiltrees = this.mercurialesComplementaire.filter(c => !this.filtres.barreGauche.find(f => !f.filtrer(this, c)))
      if (this.idFamilleSelectionnee && this.idFournisseurSelectionne && !this.mercurialesComplementaireFiltrees.find(c => c.familleId === this.idFamilleSelectionnee && c.fournisseurId === this.idFournisseurSelectionne)) {
        this.idFamilleSelectionnee = null
        this.idFournisseurSelectionne = null
        this.actions.disable(this.actions, !this.mercurialesComplementaireFiltrees)
      }
    },
    appliquerFiltre(filtrer) {
      // Nécessaire pour faire fonctionner les filtres de la barre de filtres
      filtrer(this)
    },
    executerAction(methode) {
      // Nécessaire pour faire fonctionner les actions de la barre d'action
      methode(this)
    },
    afficheIconeTri(col) {
      return this.triAsc != null && this.colonneTriee == col
    },
    trierListe(nomColonne, triNumerique) {
      let sens = this.triAsc ?? true //visiblement dans le sort, this.triAsc n'est pas connu, donc on copie dans une variable locale
      this.mercurialesComplementaireFiltrees.sort(function(a, b) {
        let i = sens ? (triNumerique ? a[nomColonne] || 0 : a[nomColonne]?.toLowerCase() || '')  : (triNumerique ? b[nomColonne] || 0 : b[nomColonne]?.toLowerCase() || '')
        let j = sens ? (triNumerique ? b[nomColonne] || 0 : b[nomColonne]?.toLowerCase() || '') : (triNumerique ? a[nomColonne] || 0 : a[nomColonne]?.toLowerCase() || '')

        //Pour que ça fonctionne aussi bien en numérique que Texte, on fait les tests
        if (i < j)
          return -1
        
        if (i > j)
          return 1
        
        return 0
      })

      //changement du sens du tri
      this.triAsc = !sens
      this.colonneTriee = nomColonne
    },
    async obtenirListeMercuriales() {
      this.isLoading = true
      this.$store.commit('uxHelpers/showSpinner')

      await this.obtenirListeFamillesCompletes()
      await this.obtenirListeFournisseursComplets()

      let response = await obtenirMercurialesComplementaires()

      this.mercurialesComplementaire = response.data

      await this.obtenirListeFamilles()
      await this.obtenirListeFournisseurs()

      this.appliquerFiltres()

      this.$store.commit('uxHelpers/hideSpinner')
      this.isLoading = false
    },
    async obtenirListeFournisseurs() {
      //Liste les fournisseurs qui ont une mercuriale complémentaire
      //On reconstruit un objet, avec la liste des fournisseurs qui ont chacun une liste de famille. ça simplifie la gestion des filtres par la suite

      let tmpFour = this.mercurialesComplementaire.reduce((acc, item) => {
        let key = item.fournisseurId
        //Ajout du fournisseur
        if (!acc.some(a => a.fournisseurId == key)) {
          acc.push({
            fournisseurId: item.fournisseurId,
            nomFournisseur: item.nomFournisseur,
            familles: []
          });
        } 

        let tmpacc = acc.filter(a => a.fournisseurId == key)

        tmpacc[0].familles.push({
          familleId: item.familleId,
          codeFamille: item.codeFamille
        });

        return acc;
      }, [])

      this.listeFournisseurs = tmpFour
    },
    async obtenirListeFamilles() {
      //Liste les familles qui ont une mercuriale complémentaire
      let tmpFamilles = this.mercurialesComplementaire.map(x => ({ valeur: x.familleId, texte: x.nomFamille }))
      this.listeFamilles = _.uniqBy(tmpFamilles, 'valeur')
      this.filtres.familles.initialiser(this)
    },
    selectFamilleDeProduit(event) {
      this.optionsFournisseurs = this.construireListeFournisseur(event.valeur, null)
      if (!this.optionsFournisseurs.find(o => o.id === this.filtreFournisseurs?.valeur)) {
        this.filtreFournisseurs = null
      }
      if (this.optionsFournisseurs?.length === 1) {
        this.filtreFournisseurs = this.optionsFournisseurs[0]
      }
      //this.filtres.fournisseurs.initialiser(this)
    },
    async obtenirListeFamillesCompletes() {
      this.optionsFamilles = this.$store.state.definitions.familles.map((t) => {
        let rObj = {}
        rObj.valeur = t.id
        rObj.texte = t.nom
        return rObj
      });
    },
    async obtenirListeFournisseursComplets() {
      let reponse = await chargerFournisseursStandardEtSpeciaux()
      this.listeTousFournisseurs = reponse.data
    },
    construireListeFournisseur(idFamille) {
      let liste = []

      if (!idFamille) {
        //Si pas d'Id famille on retourne la liste des fournisseurs qui ont une mercu complementaire
        liste = this.listeFournisseurs.map((t) => {
          let rObj = {}
          rObj.valeur = t.fournisseurId
          rObj.texte = t.nomFournisseur
          return rObj
        });
      } else {
        let tmpFour = this.listeFournisseurs.filter(f => f.familles.some(i => i.familleId === idFamille))

        liste = tmpFour.map((t) => {
          let rObj = {}
          rObj.valeur = t.fournisseurId
          rObj.texte = t.nomFournisseur
          return rObj
        });
      }

      return liste
    },
    selectionnerLigne(mercu, iMercu) {
      if (mercu.familleId === this.idFamilleSelectionnee && mercu.fournisseurId === this.idFournisseurSelectionne && this.formatDatePourApiSansSeparation(mercu.dateDebutTarif) === this.formatDatePourApiSansSeparation(this.dateDebutTarifSelectionnee) && this.formatDatePourApiSansSeparation(mercu.dateFinTarif) === this.formatDatePourApiSansSeparation(this.dateFinTarifSelectionnee)) {
        // La ligne est déjà sélectionnée, on l'ouvre
        //this.modifierDetailProduit(produit)
        this.ouvrirDetailMercuriale()
        return
      }

      this.idFamilleSelectionnee = mercu.familleId
      this.idFournisseurSelectionne = mercu.fournisseurId
      this.dateDebutTarifSelectionnee = mercu.dateDebutTarif
      this.dateFinTarifSelectionnee = mercu.dateFinTarif
      this.idMercurialeSelectionnee = iMercu
      
      this.actions.disableExporter(this.actions, !(this.idFournisseurSelectionne && this.idFamilleSelectionnee && this.dateDebutTarifSelectionnee))
      this.actions.disableSupprimer(this.actions, !this.mercurialeModifiable)
      this.actions.disableArreter(this.actions, !this.mercurialeArretable)

      this.keySel++ //Pour reconstuire la page et etre certain de surligner la bonne ligne sélectionnée
    },
    ligneEstSelectionnee(mercu) {
      return mercu.familleId === this.idFamilleSelectionnee && mercu.fournisseurId === this.idFournisseurSelectionne && this.formatDatePourApiSansSeparation(mercu.dateDebutTarif) === this.formatDatePourApiSansSeparation(this.dateDebutTarifSelectionnee) && this.formatDatePourApiSansSeparation(mercu.dateFinTarif) === this.formatDatePourApiSansSeparation(this.dateFinTarifSelectionnee)
    },
    ouvrirDetailMercuriale() {
      let destination = {
        name: "DetailMercuComplementaire",
        params: { familleId: this.idFamilleSelectionnee, fournisseurId: this.idFournisseurSelectionne, dateDebutTarif: this.formatDatePourApiSansSeparation(this.dateDebutTarifSelectionnee), dateFinTarif: this.formatDatePourApiSansSeparation(this.dateFinTarifSelectionnee) }
      }
      this.$router.push(destination)
    },
    async exporterProduits(trameVierge) {
      try {
        let response = {}

        if (trameVierge) {
          response = await exporterTrameViergeProduitsComplementaires()
          lancerTelechargementDeResponse(response)
        } else {
          //on ouvre la modale d'export avec le choix du taux à appliquer :
          this.$refs.modalExportMercuComplementaire.show()
        }        

      } finally {
        this.enExportation = false
      }
    },
    async exporterMercuriale(mercuSelectionnee) {
      if ((this.idFournisseurSelectionne && this.idFamilleSelectionnee && this.dateDebutTarifSelectionnee)) {
        let foId = this.idFournisseurSelectionne
        let faId = this.idFamilleSelectionnee
        let dt = this.dateDebutTarifSelectionnee

        this.enExportation = true
        let response = await exporterProduitsComplementaires(foId, faId, this.formatDatePourApiSansSeparation(dt), mercuSelectionnee.valeur)
        lancerTelechargementDeResponse(response)
      }
    },
    importerProduits() {
      this.$refs.modalImportMercuComplementaire.show()
    },
    demandeDateFin() {
      this.$refs.modalDemandeDate.show()
    },
    async arreterMercuriale(event) {
      await arreterMercurialesComplementaires(this.idFournisseurSelectionne, this.idFamilleSelectionnee, this.formatDatePourApiSansSeparation(this.dateDebutTarifSelectionnee), this.formatDatePourApiSansSeparation(event) )
      this.alerteSucces("Mercuriale arrêtée à la date choisie !")
      await this.obtenirListeMercuriales()    
    },
    async supprimerProduits() {
      if (this.dateDebutTarifSelectionnee <= new Date())
        this.alerteErreur("Impossible de supprimer des tarifs actifs !")
      else {
        let merc = this.mercurialeSelectionnee
        let ok = await this.alerteConfirmation("Supprimer la mercuriale", "Etes-vous certain de vouloir supprimer tous les produits/tarifs de " + merc.nomFournisseur + " sur la famille " + merc.nomFamille + " du " + this.formatHumanDateAvecSlashes(merc.dateDebutTarif) + " ?");
        if (ok) {
          await supprimerProduitsComplementaires(this.idFournisseurSelectionne, this.idFamilleSelectionnee, this.formatDatePourApiSansSeparation(this.dateDebutTarifSelectionnee))
          this.alerteSucces("Mercuriale supprimée !")
          await this.obtenirListeMercuriales()    
        }
      }
    }
  },
  async mounted() {
    await this.obtenirListeMercuriales()
    //await this.obtenirListeFournisseurs()

    this.filtres.initialiser(this)
    this.actions.initialiser(this)
  },
  created() {
    

    
  }

}
</script>

<style>

</style>
